var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.missingData)?_c('div',{staticClass:"page-break"},[_c('source-count-table',{attrs:{"title":"Insufficient data to generate the requested estimate","note":_vm.note,"columnHeadings":_vm.columnHeadings,"rows":_vm.rows,"footer":"Below is the portion of the analysis that could be completed:"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }